export const GET_STAKES_REQUEST = 'GET_STAKES_REQUEST';
export const GET_STAKES_DATA = 'GET_STAKES_DATA';
export const GET_STAKES_ERROR = 'GET_STAKES_ERROR';

export const UPDATE_QUICK_FILTER = 'UPDATE_QUICK_FILTER';
export const FILTER_STAKES = 'FILTER_STAKES';
export const SET_STAKES_SORT_DATA = 'SET_STAKES_SORT_DATA';
export const SORT_STAKES = 'SORT_STAKES';